import ReactGA from "react-ga4";
import { config } from "../config";
import ReactPixel from "react-facebook-pixel";

const GA_ID = config.ga;
const GA_ID_BRAND = config.gaBrand || '';

interface IUserPropertyProps {
  userId: number,
  platform: string,
}

export const initializeGA = () => {
  const DATA = [
    { trackingId: `${GA_ID}` },
  ];

  if (!!GA_ID_BRAND) {
    DATA.push({ trackingId: `${GA_ID_BRAND}` });
  }

  ReactGA.initialize(DATA);
}

const setPageview = (value: string) => {
  if (window.hasOwnProperty('dataLayer')) {
    ReactGA.send({ hitType: "pageview", page: value});
  }
  if (typeof (window as any)?.fbq === 'function') {
    ReactPixel.pageView();
  }
};

const setUserId = (value: number | null) => {
  if (window.hasOwnProperty('dataLayer')) {
    ReactGA.set({ userId: value });
  }
};

const setUserProperty = ({ userId, platform }: IUserPropertyProps) => {
  if (window.hasOwnProperty('dataLayer')) {
    ReactGA.gtag("set", "user_properties", {
      userId: userId,
      platform: platform
    });
    ReactGA.gtag('config', `${config.ga}`, {
      'user_id': userId,
    });
  }
};

const setLogin = () => {
  if (window.hasOwnProperty('dataLayer')) {
    ReactGA.gtag("event", "login");
  }
  if (typeof (window as any)?.fbq === 'function') {
    ReactPixel.track('Lead');
  }
};

const setLogout = () => {
  if (window.hasOwnProperty('dataLayer')) {
    ReactGA.gtag("event", "logout");
  }
};

const setSignUp = () => {
  if (window.hasOwnProperty('dataLayer')) {
    ReactGA.gtag("event", "sign_up");
  }

  if (typeof (window as any)?.fbq === 'function') {
    ReactPixel.track('CompleteRegistration');
  }
};

const sendAction = (action: string, value: string) => {
  if (window.hasOwnProperty('dataLayer')) {
    ReactGA.gtag("event", action, value);
  }
};

const logEvent = (category = '', action = '') => {
  if (category && action) {
    if (window.hasOwnProperty('dataLayer')) {
      ReactGA.event({ category, action });
    }
  }
};


export const gaEvents = {
  setPageview,
  setUserId,
  setUserProperty,
  setLogin,
  setLogout,
  setSignUp,
  sendAction,
  logEvent,
}
